import { Component } from '@verndale/core';
import ReadMore from './article-read-more';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $listing: this.el.querySelectorAll('.card'),
      $readMoreBtn: this.el.querySelector('.products-grid__cta')
    };
    this.maxArticles = parseInt(this.el.dataset.maxArticles, 10);
    this.initialArticles = parseInt(this.el.dataset.initialArticles, 10);
    this.readMore = new ReadMore({
      items: this.dom.$listing,
      readMoreBtn: this.dom.$readMoreBtn,
      maxArticles: this.maxArticles,
      element: this.el,
      itemsFirstTime: this.initialArticles
    });

    if (this.dom.$listing.length < 5) {
      this.dom.$readMoreBtn.hidden = true;
    }
  }

  addListeners() {
    this.dom.$readMoreBtn.addEventListener('click', () =>
      this.readMore.handleReadMore()
    );
  }
}

export default Module;
